<div class="search-item-wrapper">
  <div class="tag-wrapper">
    <app-color-tag [tagTitle]="item().type" [withBMargin]="false"></app-color-tag>
    @if (item().publishDate || item().date) {
      <app-divider></app-divider>
      <app-is-new-tag [newsDate]="(item().publishDate || item().date )  | onlyDate"></app-is-new-tag>
    }
  </div>
  <a [routerLink]="[itemLink()]" target="{{newTabLink() ? '_blank' : '_self' }}">
    <p [innerText]="item().title"
       class="search-item-title text-l text--semi-bold"></p>
    <p [innerHTML]="description() | removeHtml"
       class="search-item-description"></p>
  </a>
</div>
